import React, {useEffect, useState} from 'react';
import { jsonResponseHandler } from '../../utils/FetchHelper'
import CommentSettingForm from '../../components/comments/setting/CommentSettingForm'
import SpamFilterApp from '../SpamFilterApp';
import LoadingBox from "../../components/common/LoadingBox";
import {useDispatch} from "react-redux";
import LoadErrorBox from "../../components/common/LoadErrorBox";
import * as InitStatus from '../../constants/common/InitializationStatus';
import {addPrefix} from "../../utils/UriUtil";

function Body({initialized, data}) {
  if (initialized === InitStatus.INIT_SUCCESS) {
    return (
      <>
        <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
        <h3 className="tit_cont">댓글·방명록 설정</h3>
        <CommentSettingForm data={data} />
        <h3 className="tit_cont">스팸필터</h3>
        <SpamFilterApp data={data} />
      </>
    )
  } else if (initialized === InitStatus.INIT_DOING) {
    return <LoadingBox />
  } else if (initialized === InitStatus.INIT_FAIL) {
    return <LoadErrorBox retry={this.init}/>
  } else {
    return null
  }
}

export default function CommentSettingApp() {
  const dispatch = useDispatch()
  const [initialized, setInitialized] = useState(InitStatus.INIT_READY)
  const [data, setData] = useState(null)

  function init() {
    setInitialized(InitStatus.INIT_DOING)
    fetch(addPrefix("/manage/setting/comments.json"), {
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        setData(data)
        setInitialized(InitStatus.INIT_SUCCESS)
      })
      .catch(e => {
        console.error(e);
        setInitialized(InitStatus.INIT_FAIL)
      })
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <div className="inner_article reply_article">
      <Body data={data} initialized={initialized}/>
    </div>
  )
}
